

export class GeneralDynamicContent {
    id?: string;
    lastModifiedUser?: string;
    updatingDate?: Date;
    creationDate?: Date;
    reference: string;
    content: any;
    layout: any;
    image: any;
    shortContent: string;
    url: string;

    status: any; // Statut: Archivé, publié, brouillon (CONTENT_STATUS)
    publishedOrder: number; // Ordre de publication
    lang: string; // Langues de publication - code pays

    constructor(){}

}
